import Info1Content from '../components/info/Info1PageContent';

const Info1Page = () => {
  return <Info1Content />;
};

export default Info1Page;